import angular from 'angular';

export default class TimeBlocksService {
  constructor(AlertService, Authentication) {
    'ngInject';

    Object.assign(this, { AlertService, Authentication });
    this.init();
  }

  init() {
    this.shiftTemplates = [];
    if (this.Authentication.user.orgSettings.shiftTemplates) {
      this.shiftTemplates = [...this.Authentication.user.orgSettings.shiftTemplates];
    }
  }

  saveTimeBlocks() {
    if (
      this.Authentication.user.isManager &&
      angular.toJson(this.shiftTemplates) !==
        angular.toJson(this.Authentication.user.orgSettings.shiftTemplates)
    ) {
      const payload = { shiftTemplates: this.shiftTemplates };
      return this.Authentication.user.orgSettings.customPUT(payload).then((data) => {
        this.Authentication.user.orgSettings = data;
        return true;
      });
    }
  }

  get timeBlocks() {
    return this.shiftTemplates;
  }

  addTimeBlock(shiftTemplate) {
    this.shiftTemplates = [...this.shiftTemplates, shiftTemplate];
    this.saveTimeBlocks();
    this.AlertService.success('Successfully created time block');
  }

  editTimeBlock(shiftTemplate, updatedTimeBlock) {
    const index = this.shiftTemplates.indexOf(shiftTemplate);

    if (index >= 0) {
      this.shiftTemplates[index] = updatedTimeBlock;
      this.saveTimeBlocks();
      this.AlertService.success('Successfully edited time block');
    }
  }

  deleteTimeBlock(shiftTemplate) {
    const index = this.shiftTemplates.findIndex(
      (template) =>
        template.time === shiftTemplate.time &&
        template.locationLabel === shiftTemplate.locationLabel &&
        template.break === shiftTemplate.break
    );

    if (index >= 0) {
      this.shiftTemplates.splice(index, 1);
      this.saveTimeBlocks();
      this.AlertService.success('Successfully deleted time block');
    }
  }
}
